const request = (options)=>{
    //let url = "http://192.168.2.70"
    if(!window){
        window = {}
    }
    if(!window.host){
        window.host = "";
    }
    let url = window.host + options.url;
    let cors = {} ; 
    if(options.cors){
        cors =  {
            crossDomain: true,
            xhrFields: {
               withCredentials: true
            }
        }
    }

    return new Promise((resolve , reject)=>{
        try {
            $.ajax({
                type: options.method || options.type || "GET",
                url: url,
                data: options.data || {},
                dataType: options.dataType || "json",
                headers: options.headers || {},
                // crossDomain:true, 
                // xhrFields: { 
                //     withCredentials: true //默认情况下，标准的跨域请求是不会发送cookie的
                // },
                success:  (res)=> {
                    resolve(res);
                },
                error: (e , t , r)=>{
                    console.log(e);
                    //reject([e,t,r]);
                    resolve({
                        success: false ,
                        msg: t
                    })
                },
                ...cors
            });
        }catch(ex){
            console.log(ex);
            resolve({
                success:false,
                msg: "服务忙,请稍后..."
            });
        }
    });
}
export default request;